// Shared by RecentShowRow and Performers - the "N (M%)" rendering of a fan
// interest count, consistent wherever a performer's share of the vote shows up.
export const formatInterestCount = (
  count: number | null,
  percentage: number | null,
): string | number => {
  if (count == null) return "n/a"
  return percentage != null ? `${count} (${percentage}%)` : count
}
